var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.119,
    height: 37.119,
    viewBox: "0 0 37.119 37.119",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#b6b6b6;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M224.113,214.993l6.037-3.477-6.037-3.477Zm0,0",
    transform: "translate(-207.865 -192.957)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.56,0a18.56,18.56,0,1,0,18.56,18.56A18.562,18.562,0,0,0,18.56,0Zm11.6,18.579a30.632,30.632,0,0,1-.477,5.579A2.906,2.906,0,0,1,27.635,26.2c-1.815.478-9.075.478-9.075.478s-7.241,0-9.075-.5A2.906,2.906,0,0,1,7.44,24.138a30.5,30.5,0,0,1-.478-5.579,30.612,30.612,0,0,1,.478-5.579,2.965,2.965,0,0,1,2.044-2.063c1.815-.478,9.075-.478,9.075-.478s7.26,0,9.075.5a2.906,2.906,0,0,1,2.044,2.044,29.069,29.069,0,0,1,.477,5.6Zm0,0",
    transform: "translate(0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.d244093dea1c63cd4c1dfa96ea00ca21.svg";
export { ForwardRef as ReactComponent };